import { useMutation, useQueryClient } from "react-query";
import {
  removeCustomer,
  createCustomer,
  updateCustomer,
  toggleCustomerLoyaltyEligibity,
  updateWriteOff,
} from "../../../services/customer";

export const useCreateCustomerMutation = () => {
  const queryClient = useQueryClient();
  return useMutation((data) => createCustomer(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getCustomers"]);
    },
  });
};

export const useEditCustomerMutation = ({ id }) => {
  const queryClient = useQueryClient();
  return useMutation((data) => updateCustomer(data), {
    onSuccess: () => {
      queryClient.invalidateQueries(["getCustomerDetails", `${id}`]);
      queryClient.invalidateQueries(["getCustomers"]);
    },
  });
};

export const useDeleteCustomerMutation = () => {
  return useMutation((data) => removeCustomer(data));
};

export const useCustomerLoyaltyEligibilityToggleMutation = () => {
  return useMutation((data) => toggleCustomerLoyaltyEligibity(data));
};

export const useWriteOffMutation = () => {
  return useMutation((data) => updateWriteOff(data));
};
